<script lang="ts">
	import ArticleCard from '$lib/ArticleCard.svelte';
	import Container from '$lib/Container.svelte';
	import Pagination from '$lib/Pagination.svelte';
	import StrapiContent from '$lib/StrapiContent.svelte';
	import StrapiImage from '$lib/StrapiImage.svelte';
	import { getImageUrl } from '$lib/utils';
	import type { PageData } from './$types';

	interface Props {
		data: PageData;
	}

	let { data }: Props = $props();
	let { author, articles, pagination } = $derived(data);
</script>

<Container wrapperClass="page-pb">
	<section class="section-mb max-w-screen-md">
		<div class="mb-5 flex max-w-screen-md flex-col gap-5 lg:flex-row">
			<StrapiImage
				cover={author.photo}
				alt={author.photo.alternativeText}
				class="aspect-square w-20 self-start rounded-full object-cover lg:w-28"
			/>

			<div class="shrink">
				<h1 class="h2 mb-1">{author.name}</h1>
				<p class="body-bold mb-1">
					{#if author.title}
						{author.title}
					{/if}
					{#if author.title && author.position}
						<span class="text-gray-mid">&nbsp;·&nbsp;</span>
					{/if}
					{#if author.position}
						{author.position}
					{/if}
				</p>
				{#if author.linkedin}
					<a href={author.linkedin} aria-label="linkedin">
						<i class="icon icon-social-linkedin text-2xl text-[#0077b5]"></i>
					</a>
				{/if}
			</div>
		</div>
		<StrapiContent content={author.biography} />
	</section>

	<section>
		<h2 class="h3 mb-6">Latest from {author.name}</h2>
		<ul class="divide-gray-light mb-5 grid divide-y lg:grid-cols-3 lg:gap-x-10 lg:divide-none">
			{#each articles as article (article.id)}
				<li>
					<a href={`/${article.slug}`}>
						<ArticleCard
							title={article.title}
							thumbnail={getImageUrl(article.cover)}
							alt={article.cover.alternativeText}
							slug={article.slug}
							publishedAt={article.publishedAt}
							themes={article.themes.map((theme) => theme.name)}
						/>
					</a>
				</li>
			{/each}
		</ul>
		<section class="flex w-full justify-center lg:justify-end">
			<Pagination pageSize={pagination.pageSize} totalItems={pagination.total} />
		</section>
	</section>
</Container>
